import React from 'react'
import Python from '../../assets/images/Python.png'
import Java from '../../assets/images/Java.svg'
import Js from '../../assets/images/js.svg'
import react from '../../assets/images/react.svg'
import Cpp from '../../assets/images/Cpp.png'
import Git from '../../assets/images/Git.png'
import MySQL from '../../assets/images/MySQL.svg'
import Django from '../../assets/images/Django.svg'
import Nodejs from '../../assets/images/Nodejs.png'
import './style.css'

const Experience = () => {
  return (
    <section id='experience'>
      <h5>What Skills I Have</h5>
      <h2>My Experience</h2>

      <div className="container experience_container">

        <div className="skill">
          <img src={Python} alt="Python" className="" />
          <h3 className="">Python</h3>
        </div>

        <div className="skill">
          <img src={Java} alt="Java" className="" />
          <h3 className="">Java</h3>
        </div>

        <div className="skill">
          <img src={Js} alt="Js" className="" />
          <h3 className="">Javascript</h3>
        </div>

        <div className="skill">
          <img src={react} alt="react" className="" />
          <h3 className="">React</h3>
        </div>

        <div className="skill">
          <img src={MySQL} alt="MySQL" className="" />
          <h3 className="">MySQL</h3>
        </div>

        <div className="skill">
          <img src={Cpp} alt="Cpp" className="" />
          <h3 className="">C++</h3>
        </div>

        <div className="skill">
          <img src={Git} alt="Git" className="" />
          <h3 className="">Git</h3>
        </div>

        <div className="skill">
          <img src={Django} alt="Django" className="" />
          <h3 className="">Django</h3>
        </div>

        <div className="skill">
          <img src={Nodejs} alt="Nodejs" className="" />
          <h3 className="">Nodejs</h3>
        </div>

      </div>
    </section>
  )
}

export default Experience